<script setup lang="ts">
import { PanelLeftOpen, PanelRightOpen } from 'lucide-vue-next'
import type { HTMLAttributes } from 'vue'
import { Button } from '@/foundation/button'
import { cn } from '@/foundation/utils'
import { useSidebar } from './utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const { toggleSidebar, state } = useSidebar()
</script>

<template>
  <Button data-sidebar="trigger" variant="ghost" size="icon" :class="cn('h-7 w-7', props.class)" @click="toggleSidebar">
    <component :is="state === 'expanded' ? PanelRightOpen : PanelLeftOpen" />
    <span class="sr-only">Toggle Sidebar</span>
  </Button>
</template>
